/** @format */

import { useNavigate } from "react-router-dom";
import Table from "../../extra/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getSellerRequest, acceptSellerRequest, rejectSellerRequest } from "../../store/sellerRequest/sellerRequest.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import { warningAccept } from "../../../util/Alert";
import swal from "sweetalert";
import defaultImage from "../../../assets/images/default.jpg";
import { colors } from "../../../util/SkeletonColor";
import Skeleton from "react-loading-skeleton";
import SellerRequestDetail from "./SellerRequestDetail";
import Button from "../../extra/Button";
import InitialsAvatar from "../../extra/InitialsAvatar";

const SellerRequest = (props) => {
	const [page, setPage] = useState(0);
	const [data, setData] = useState([]);
	console.log("data", data);

	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(true);
	const [viewDetail, setViewDetail] = useState(null);

	const [rowsPerPage, setRowsPerPage] = useState(10);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { sellerRequest } = useSelector((state) => state.sellerRequest);
	const { dialogue, dialogueType, dialogueData } = useSelector((state) => state.dialogue);

	useEffect(() => {
		dispatch(getSellerRequest());
	}, [dispatch]);
	useEffect(() => {
		setData(sellerRequest);
	}, [sellerRequest]);

	// // pagination
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event, 10));
		setPage(0);
	};

	const handleClick = (id) => {
		const data = warningAccept();
		data.then((isDeleted) => {
			if (isDeleted) {
				dispatch(acceptSellerRequest(id));
			}
		}).catch((err) => console.log(err));
	};

	const handleReject = (id) => {
		swal({
			title: "Reject Seller Request",
			text: "Please provide a reason for rejection:",
			content: {
				element: "input",
				attributes: {
					placeholder: "Reason for rejection (optional)",
					type: "text",
				},
			},
			buttons: {
				cancel: "Cancel",
				confirm: {
					text: "Reject",
					value: true,
					className: "swal-button--danger",
				},
			},
			dangerMode: true,
		})
			.then((reason) => {
				if (reason !== null) {
					dispatch(rejectSellerRequest(id, typeof reason === "string" ? reason : ""));
				}
			})
			.catch((err) => console.log(err));
	};

	// searching
	const handleFilterData = (filteredData) => {
		if (typeof filteredData === "string") {
			setSearch(filteredData);
		} else {
			setData(filteredData);
		}
	};

	const handleEdit = (id) => {
		navigate("/admin/sellerRequestEdit", {
			state: id,
		});
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500);
		return () => clearTimeout(timer);
	}, []);

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className='fw-normal'>{page * rowsPerPage + parseInt(index) + 1}</span>,
		},
		{
			Header: "Seller",
			body: "name",
			Cell: ({ row }) => {
				const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
				return loading ? (
					<div className='d-flex align-items-center'>
						<Skeleton circle height={40} width={40} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
						<div className='ms-2'>
							<Skeleton width={120} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
							<Skeleton width={160} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
						</div>
					</div>
				) : (
					<div className='d-flex align-items-center text-start'>
						<InitialsAvatar src={row?.image} name={fullName} size={40} />
						<div className='ms-2'>
							<div className='fw-semibold text-capitalize' style={{ color: "#0f172a", lineHeight: "1.2" }}>
								{fullName || "-"}
							</div>
							{row?.email && <div style={{ fontSize: "12px", color: "#64748b" }}>{row.email}</div>}
						</div>
					</div>
				);
			},
		},
		{
			Header: "Store",
			body: "storeName",
			Cell: ({ row }) => {
				const store = row?.storeName || row?.businessName || "-";
				const sub = row?.businessName && row?.storeName && row.businessName !== row.storeName ? row.businessName : null;
				return (
					<div className='text-start'>
						<div className='fw-semibold' style={{ color: "#0f172a", lineHeight: "1.2" }}>
							{store}
						</div>
						{sub && <div style={{ fontSize: "12px", color: "#64748b" }}>{sub}</div>}
					</div>
				);
			},
		},
		{
			Header: "Gender",
			body: "gender",
			Cell: ({ row }) => <span className='mb-0'>{row?.gender ? row?.gender : "-"}</span>,
		},
		{
			Header: "Country",
			body: "country",
			Cell: ({ row }) => <span className=''>{row?.address?.country || "-"}</span>,
		},
		{
			Header: "Actions",
			body: "",
			Cell: ({ row }) => (
				<div className='d-flex' style={{ gap: "8px", justifyContent: "center" }}>
					<button
						title='Approve'
						onClick={() => handleClick(row._id)}
						style={{
							border: "none",
							backgroundColor: "#dcfce7",
							color: "#16a34a",
							width: "36px",
							height: "36px",
							borderRadius: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							cursor: "pointer",
							transition: "transform 0.1s",
						}}
						onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
						onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}>
						<i className='bi bi-check-lg' style={{ fontSize: "18px" }} />
					</button>
					<button
						title='Reject'
						onClick={() => handleReject(row._id)}
						style={{
							border: "none",
							backgroundColor: "#fee2e2",
							color: "#dc2626",
							width: "36px",
							height: "36px",
							borderRadius: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							cursor: "pointer",
							transition: "transform 0.1s",
						}}
						onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
						onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}>
						<i className='bi bi-x-lg' style={{ fontSize: "16px" }} />
					</button>
					<button
						title='View details'
						onClick={() => setViewDetail(row)}
						style={{
							border: "none",
							backgroundColor: "#e0f2fe",
							color: "#0369a1",
							width: "36px",
							height: "36px",
							borderRadius: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							cursor: "pointer",
							transition: "transform 0.1s",
						}}
						onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.95)")}
						onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}>
						<i className='bi bi-eye-fill' style={{ fontSize: "16px" }} />
					</button>
				</div>
			),
		},
		{
			Header: "Submitted",
			body: "createdAt",
			Cell: ({ row }) => <span className=''>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>,
		},
	];
	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>Pending Seller </div>
					<div className='sellerMain'>
						<div className='tableMain mt-2'>
							<div className='sellerHeader primeHeader'>
								<div className='row'>
									<div className='col-2'></div>

									<div className='col-10'>
										<Searching type={"client"} data={sellerRequest} setData={setData} onFilterData={handleFilterData} serverSearching={handleFilterData} />
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} PerPage={rowsPerPage} Page={page} type={"client"} />
							<Pagination component='div' count={sellerRequest?.length} serverPage={page} type={"client"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={sellerRequest?.length} onRowsPerPageChange={handleChangeRowsPerPage} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
			{viewDetail && (
				<SellerRequestDetail
					data={viewDetail}
					onClose={() => setViewDetail(null)}
					onApprove={() => {
						handleClick(viewDetail._id);
						setViewDetail(null);
					}}
					onReject={() => {
						handleReject(viewDetail._id);
						setViewDetail(null);
					}}
				/>
			)}
		</>
	);
};

export default connect(null, { getSellerRequest, acceptSellerRequest, rejectSellerRequest })(SellerRequest);
// export default Seller;
